import { useEffect, useState } from "react";
import {
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Button,
    Typography,
    Box,
    CircularProgress,
} from "@mui/material";
import { User } from "../../../types/userTypes";
import SuperAdminCompanyService from './../../../service/superadmin/companyService';

interface ViewUserProps {
    open: boolean;
    onClose: () => void;
    user: User | null;
    loading: boolean;
}

const ViewUser: React.FC<ViewUserProps> = ({ open, onClose, user, loading }) => {
    const [companyName, setCompanyName] = useState<string | null>(null);
    const [companyLoading, setCompanyLoading] = useState<boolean>(false);

    useEffect(() => {
        if (user?.company_id) {
            setCompanyLoading(true);
            SuperAdminCompanyService.getCompanyList()
                .then((companies) => {
                    // Ensure company_id is compared as a string
                    const company = companies.find((c: { id: number }) => c.id.toString() === user.company_id);
                    setCompanyName(company ? company.company_name : "Unknown Company");
                })
                .catch(() => {
                    setCompanyName("Unknown Company");
                })
                .finally(() => setCompanyLoading(false));
        } else {
            setCompanyName(null);
        }
    }, [user?.company_id]);

    return (
        <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
            <DialogTitle>User Details</DialogTitle>
            <DialogContent>
                {loading ? (
                    <CircularProgress />
                ) : user ? (
                    <Box>
                        <Typography><strong>Username:</strong> {user.username}</Typography>
                        <Typography><strong>Email:</strong> {user.email}</Typography>
                        <Typography><strong>Phone:</strong> {user.phone}</Typography>
                        <Typography><strong>Address:</strong> {user.address}</Typography>
                        <Typography><strong>Role:</strong> {user.role}</Typography>
                        <Typography><strong>Status:</strong> {user.status === "1" ? "Active" : "Inactive"}</Typography>
                        <Typography><strong>Company Admin:</strong> {user.is_company_admin === "1" ? "Yes" : "No"}</Typography>
                        <Typography>
                            <strong>Company:</strong>{" "}
                            {companyLoading ? <CircularProgress size={15} /> : companyName || "No Company Assigned"}
                        </Typography>
                        <Typography><strong>Created At:</strong> {user.created_at}</Typography>
                    </Box>
                ) : (
                    <Typography>No user data found.</Typography>
                )}
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose} color="primary">Close</Button>
            </DialogActions>
        </Dialog>
    );
};

export default ViewUser;
